import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SideMenuLayout } from '@/components/SideMenuLayout';

function RouteComponent() {
  return (
    <SideMenuLayout title="Vorgänge" fullHeight>
      <Outlet />
    </SideMenuLayout>
  );
}

export const Route = createFileRoute('/_authenticated/_management/vorgaenge')({
  component: RouteComponent,
});
